import $ from 'jquery';
window.$ = window.jQuery = $;
import gsap from 'gsap';
import TweenMax from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import ScrollToPlugin from 'gsap/ScrollToPlugin';
import Chart from 'chart.js/auto';
import SimpleBar from 'simplebar';
window.Chart = Chart;
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);
require('jquery-validation');
require('owl.carousel');
require('@fancyapps/fancybox');
import tippy from 'tippy.js';

import ResizeObserver from 'resize-observer-polyfill';
window.ResizeObserver = ResizeObserver;

// Animation utility functions
const animateElement = (selector, animationProps) => {
    gsap.to(selector, animationProps);
};

$('.custom-table').each(function() {
    if (!$(this).parent().hasClass('custom-table-wrapper')) {
        $(this).wrap('<div class="custom-table-wrapper"></div>');
    }
});

function wrapCustomTables($context) {
    $context.find('.custom-table').each(function() {
        if (!$(this).parent().hasClass('custom-table-wrapper')) {
            $(this).wrap('<div class="custom-table-wrapper"></div>');
        }
    });
}

function initCustomScrollbars(context) {
    var root = context || document;
    var scrollbars = [];

    if (root.matches && root.matches('.custom-scrollbar')) {
        scrollbars.push(root);
    }

    if (root.querySelectorAll) {
        scrollbars = scrollbars.concat(Array.prototype.slice.call(root.querySelectorAll('.custom-scrollbar')));
    }

    Array.prototype.forEach.call(scrollbars, function(el) {
        if (!SimpleBar.instances.has(el)) {
            new SimpleBar(el, { autoHide: false, forceVisible: 'y' });
        }
    });
}

function toggleCompareLimitMessage(shouldShow, scope) {
    var selector = scope === 'mobile' ? '[data-compare-mobile-limit-message]' : '[data-compare-limit-message]';
    var message = document.querySelector(selector);
    if (!message) return;

    message.hidden = !shouldShow;

    if (shouldShow) {
        message.scrollIntoView({ behavior: 'smooth', block: 'center' });
        message.focus();
    }
}

$(document).on('DOMContentLoaded', function() {
    initCustomScrollbars(document);

    var customScrollbarObserver = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            Array.prototype.forEach.call(mutation.addedNodes, function(node) {
                if (node.nodeType === 1) {
                    initCustomScrollbars(node);
                }
            });
        });
    });

    customScrollbarObserver.observe(document.body, { childList: true, subtree: true });

    $('[data-tooltip-html]').each(function(index, element) {        
        tippy(element, {
            content: $(element).data('tooltip-html'),
            allowHTML: true,
            theme : 'custom'
        });
    });    

    //Menu
    var isHoverDevice = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    $('.menu-item-has-children > a').on('click', function(e) {
        if (!isHoverDevice) e.preventDefault();
    });
    var menuCloseTimer;

    if (isHoverDevice) {
        // Desktop: mouseover ile aç/kapat
        $('.menu-item-has-children').on('mouseenter', function() {
            clearTimeout(menuCloseTimer);
            $('.menu-item-has-children').not(this).removeClass('active');
            $('.product-action').removeClass('active');
            $(this).addClass('active');
            $('body').addClass('menu-open');
        }).on('mouseleave', function() {
            var $item = $(this);
            menuCloseTimer = setTimeout(function() {
                $item.removeClass('active');
                if (!$('.menu-item-has-children.active').length) {
                    $('body').removeClass('menu-open');
                }
            }, 100);
        });
    } else {
        // Mobile/touch: click ile aç/kapat
        $('.menu-item-has-children').on('click', function() {
            $('.product-action').removeClass('active');

            if ($(this).hasClass('active')) {
                $('.menu-item-has-children').removeClass('active');
                $('body').removeClass('menu-open');
            } else {
                $('.menu-item-has-children').removeClass('active');
                $(this).addClass('active');
                $('body').addClass('menu-open');
            }
        });
    }

    $('.dropdown-menu').on('mouseenter', function() {
        clearTimeout(menuCloseTimer);
    }).on('mouseleave', function() {
        if (!isHoverDevice) return;
        menuCloseTimer = setTimeout(function() {
            $('.menu-item-has-children').removeClass('active');
            $('body').removeClass('menu-open');
        }, 100);
    });

    $('.dropdown-menu').on('click', function(e) {
        e.stopPropagation();
    });

    $('.menu-overlay').on('click', function() {
        $('.menu-item-has-children').removeClass('active');
        $('body').removeClass('menu-open');
    });

    $('.product-action-button').on('click', function(e) {
        e.stopPropagation();
        $('.menu-item-has-children').removeClass('active');
        $('body').removeClass('menu-open');

        if ($(this).parents('.product-action:first').hasClass('active')) {
            $(this).parents('.product-action:first').removeClass('active');
        } else {
            $(this).parents('.product-action:first').addClass('active');
        }
    });

    $('.product-action-menu').on('click', function(e) {
        e.stopPropagation();
    });

    $('.product-action-menu .closer-button').on('click', function() {
        $('.product-action').removeClass('active');
    });

    // Shared date range panel toggle
    $('[data-daterange-toggle]').on('click', function(e) {
        e.preventDefault();

        var $button = $(this);
        var $panel = $button
            .closest('.product-performance-content, .product-performance-box-header')
            .find('[data-daterange-panel]')
            .first();

        if (!$panel.length) return;

        var isOpen = !$panel.prop('hidden');
        $panel.prop('hidden', isOpen);
        $button.attr('aria-expanded', !isOpen);
    });

    const syncCompareDateTools = link => {
        const range = link.dataset.range || '';
        const section = link.closest('.product-compare');
        const dateTools = section?.querySelector('[data-compare-date-tools]');
        if (!section || !dateTools) return;

        section.classList.toggle('is-compare-date-range-visible', range === 'custom');
        dateTools.hidden = range !== 'custom';
    };

    document.querySelectorAll('.product-compare .product-compare-box-header [data-range]').forEach(link => {
        if (link.closest('.segmented-control-item')?.classList.contains('active')) {
            syncCompareDateTools(link);
        }

        link.addEventListener('click', event => {
            event.preventDefault();
            link.closest('.segmented-control-component')?.querySelectorAll('.segmented-control-item').forEach(item => {
                item.classList.toggle('active', item.contains(link));
            });
            syncCompareDateTools(link);
        });
    });

    // Shared performance date validation
    function validatePerformanceTableDateOrder($panel) {
        var $startDateInput = $panel.find('[data-performance-table-start]');
        var $endDateInput = $panel.find('[data-performance-table-end]');
        var startDate = $startDateInput.val();
        var endDate = $endDateInput.val();

        if (!startDate || !endDate) return true;

        if (startDate <= endDate) {
            $startDateInput.removeClass('is-invalid');
            $endDateInput.removeClass('is-invalid');
            return true;
        }

        var lastChangedDateInput = $panel.data('lastChangedDateInput');
        var $invalidDateInput = lastChangedDateInput === 'start' ? $startDateInput : $endDateInput;

        $startDateInput.removeClass('is-invalid');
        $endDateInput.removeClass('is-invalid');
        $invalidDateInput.addClass('is-invalid');

        return false;
    }

    // Product detail performance table request
    $('[data-product-performance-table-submit]').on('click', function(e) {
        var $button = $(this);
        if (!$button.closest('.product-performance-content').length) return;

        e.preventDefault();

        var $panel = $button.closest('[data-daterange-panel]');
        var $content = $button
            .closest('.product-performance-content')
            .find('.product-performance-content-body');
        var endpoint = $content.data('endpoint');
        var productPageId = $content.data('product-page-id');
        var $startDateInput = $panel.find('[data-performance-table-start]');
        var $endDateInput = $panel.find('[data-performance-table-end]');
        var startDate = $startDateInput.val();
        var endDate = $endDateInput.val();
        var requestData = {};

        $startDateInput.toggleClass('is-invalid', !startDate);
        $endDateInput.toggleClass('is-invalid', !endDate);

        if (!startDate || !endDate) {
            e.stopImmediatePropagation();
            return false;
        }

        if (!validatePerformanceTableDateOrder($panel)) {
            e.stopImmediatePropagation();
            return false;
        }

        if (!endpoint) return;

        if (productPageId) {
            requestData.productPageId = productPageId;
        }

        if (startDate) {
            requestData.startDate = startDate;
        }

        if (endDate) {
            requestData.endDate = endDate;
        }

        $.ajax({
            url: endpoint,
            method: 'GET',
            data: requestData,
            success: function(response) {
                $content.html(response);
                wrapCustomTables($content);
            }
        });
    });

    // Product detail performance table reset
    $('[data-product-performance-table-clear]').on('click', function(e) {
        var $button = $(this);
        if (!$button.closest('.product-performance-content').length) return;

        e.preventDefault();

        var $panel = $button.closest('[data-daterange-panel]');
        var $content = $button
            .closest('.product-performance-content')
            .find('.product-performance-content-body');
        var endpoint = $content.data('endpoint');
        var productPageId = $content.data('product-page-id');
        var requestData = {};

        $panel.find('[data-performance-table-start], [data-performance-table-end]')
            .val('')
            .removeClass('is-invalid');

        if (!endpoint) return;

        if (productPageId) {
            requestData.productPageId = productPageId;
        }

        $.ajax({
            url: endpoint,
            method: 'GET',
            data: requestData,
            success: function(response) {
                $content.html(response);
                wrapCustomTables($content);
            }
        });
    });

    if ($('#performance-table-container').length) {
        // Performance page table request
        var performancePageCompareSelections = [];

        function getPerformancePageProductFromRow($row) {
            var key = $row.data('product-key');
            var code = $.trim($row.find('.product-code').first().text());
            var name = $.trim($row.find('.product-name-link').first().text());

            return {
                key: key,
                code: code || key,
                name: name || ''
            };
        }

        function setPerformancePageCompareSelections(products) {
            var seen = {};

            performancePageCompareSelections = products.filter(function(product) {
                if (!product.key || seen[product.key]) return false;
                seen[product.key] = true;
                return true;
            });
        }

        function removePerformancePageCompareSelection(productKey) {
            performancePageCompareSelections = performancePageCompareSelections.filter(function(product) {
                return product.key !== productKey;
            });
        }

        function getPerformancePageSelectedKeys() {
            return performancePageCompareSelections.map(function(product) {
                return product.key;
            });
        }

        function applyPerformancePageSelectedKeys(selectedKeys) {
            var selectedKeyMap = {};

            selectedKeys.forEach(function(key) {
                selectedKeyMap[key] = true;
            });

            $('[data-product-key]').each(function() {
                var $row = $(this);
                var isSelected = selectedKeyMap[$row.data('product-key')] === true;

                $row.toggleClass('compare-selected', isSelected);
                $row.find('[data-compare-toggle]').toggleClass('selected', isSelected);
            });
        }

        function loadPerformancePageTable($panel) {
            var $container = $('#performance-table-container');
            var endpoint = $container.data('endpoint');

            if (!$container.length) return;

            if (!endpoint) {
                bindPerformancePageCompareRows();
                return;
            }

            var requestData = {};
            var category = $container.data('category');
            var $startDateInput = $panel && $panel.length
                ? $panel.find('[data-performance-table-start]')
                : $('[data-performance-table-start]').filter(function() { return $(this).val(); }).first();
            var $endDateInput = $panel && $panel.length
                ? $panel.find('[data-performance-table-end]')
                : $('[data-performance-table-end]').filter(function() { return $(this).val(); }).first();
            var startDate = $startDateInput.val();
            var endDate = $endDateInput.val();
            var selectedKeys = getPerformancePageSelectedKeys();

            if (category) {
                requestData.category = category;
            }

            if (startDate && endDate) {
                requestData.startDate = startDate;
                requestData.endDate = endDate;
            }

            $container.html('');

            $.ajax({
                url: endpoint,
                method: 'GET',
                data: requestData,
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                },
                success: function(response) {
                    $container.html(response);
                    wrapCustomTables($container);
                    applyPerformancePageSelectedKeys(selectedKeys);
                    bindPerformancePageCompareRows();
                },
                error: function() {
                    $container.html('<div class="alert info-alert"><div class="alert-content"><p>Tablo verisi alınamadı.</p></div></div>');
                }
            });
        }

        function getPerformancePageCompareSelections() {
            return performancePageCompareSelections.slice();
        }

        function escapePerformancePageCompareHtml(value) {
            return $('<div>').text(value || '').html();
        }

        function renderPerformancePageCompareModal() {
            var selectedProducts = getPerformancePageCompareSelections();
            var $modal = $('#compare-selection-modal');
            var $list = $('[data-compare-selection-list]');

            if (!$modal.length || !$list.length) return;

            if (!selectedProducts.length) {
                closePerformancePageCompareModal();
                return;
            }

            $list.html(selectedProducts.map(function(product) {
                var key = escapePerformancePageCompareHtml(product.key);
                var code = escapePerformancePageCompareHtml(product.code);
                var name = escapePerformancePageCompareHtml(product.name);

                return '<li data-compare-selection-item="' + key + '">' +
                    '<span class="compare-selection-code">' + code + '</span>' +
                    '<span class="compare-selection-name">' + name + '</span>' +
                    '<button class="compare-selection-remove" type="button" data-compare-selection-remove="' + key + '" aria-label="' + code + ' seçimini kaldır">' +
                        '<i class="icon-minus"></i>' +
                    '</button>' +
                '</li>';
            }).join(''));
        }

        function openPerformancePageCompareModal() {
            renderPerformancePageCompareModal();
            $('body').addClass('compare-selection-modal-open');
            $('#compare-floating-button').addClass('is-modal-open');
            $('#compare-selection-modal').prop('hidden', false);
            $('#compare-selected-button').attr('aria-expanded', 'true');
        }

        function closePerformancePageCompareModal() {
            $('body').removeClass('compare-selection-modal-open');
            $('#compare-floating-button').removeClass('is-modal-open');
            $('#compare-selection-modal').prop('hidden', true);
            $('#compare-selected-button').attr('aria-expanded', 'false');
        }

        function clearPerformancePageCompareSelections() {
            performancePageCompareSelections = [];

            $('[data-product-key].compare-selected').each(function() {
                var $row = $(this);

                $row.removeClass('compare-selected');
                $row.find('[data-compare-toggle]').removeClass('selected');
            });

            toggleCompareLimitMessage(false);
            updatePerformancePageCompareButton();
            closePerformancePageCompareModal();
        }

        function updatePerformancePageCompareButton() {
            var selectedProducts = getPerformancePageCompareSelections();
            var selectedKeys = selectedProducts.map(function(product) {
                return product.key;
            });
            var $buttonWrapper = $('#compare-floating-button');
            var $button = $('#compare-selected-button');
            var $badge = $button.find('[data-compare-badge]');
            var isDisabled = selectedKeys.length < 2;

            if (!$buttonWrapper.length || !$button.length) return;

            $buttonWrapper.toggleClass('hidden', isDisabled);
            $button.toggleClass('disabled', isDisabled);
            $button.attr('aria-disabled', isDisabled ? 'true' : 'false');
            $button.attr('href', '#');
            $badge.prop('hidden', isDisabled).text(selectedKeys.length);

            if (isDisabled) {
                closePerformancePageCompareModal();
            } else if (!$('#compare-selection-modal').prop('hidden')) {
                renderPerformancePageCompareModal();
            }
        }

        function bindPerformancePageCompareRows() {
            $('[data-product-key]').each(function() {
                var $row = $(this);
                var $toggleButton = $row.find('[data-compare-toggle]');

                $toggleButton.off('click.performancePageCompare').on('click.performancePageCompare', function(e) {
                    e.preventDefault();
                    var product = getPerformancePageProductFromRow($row);
                    var selectedKeys = getPerformancePageSelectedKeys();
                    var isSelected = selectedKeys.indexOf(product.key) !== -1;
                    var selectedCount = selectedKeys.length;

                    if (!isSelected && selectedCount >= 4) {
                        toggleCompareLimitMessage(true);
                        return;
                    }

                    if (isSelected) {
                        removePerformancePageCompareSelection(product.key);
                    } else {
                        setPerformancePageCompareSelections(performancePageCompareSelections.concat(product));
                    }

                    applyPerformancePageSelectedKeys(getPerformancePageSelectedKeys());
                    toggleCompareLimitMessage(false);
                    updatePerformancePageCompareButton();
                });
            });

            updatePerformancePageCompareButton();
        }

        $('[data-performance-table-submit]').on('click', function(e) {
            e.preventDefault();

            var $button = $(this);
            var $panel = $button.closest('[data-daterange-panel]');
            var $startDateInput = $panel.find('[data-performance-table-start]');
            var $endDateInput = $panel.find('[data-performance-table-end]');
            var startDate = $startDateInput.val();
            var endDate = $endDateInput.val();

            $startDateInput.toggleClass('is-invalid', !startDate);
            $endDateInput.toggleClass('is-invalid', !endDate);

            if (!startDate || !endDate) {
                e.stopImmediatePropagation();
                return false;
            }

            if (!validatePerformanceTableDateOrder($panel)) {
                e.stopImmediatePropagation();
                return false;
            }

            loadPerformancePageTable($panel);
        });

        $('[data-performance-table-clear]').on('click', function(e) {
            e.preventDefault();

            var $panel = $(this).closest('[data-daterange-panel]');

            $panel.find('[data-performance-table-start], [data-performance-table-end]')
                .val('')
                .removeClass('is-invalid');

            loadPerformancePageTable($panel);
        });

        $('[data-performance-category]').on('click', function(e) {
            var $container = $('#performance-table-container');
            var $toolsItem = $(this).closest('.product-performance-content-tools-item');

            if (!$container.length) return;

            e.preventDefault();

            var category = $(this).data('performance-category') || '';
            $container.data('category', category);
            $('[data-performance-category]').parent().removeClass('active');
            $(this).parent().addClass('active');
            $toolsItem.removeClass('is-open');
            $toolsItem.find('.performance-segment-mobile-toggle')
                .attr('aria-expanded', 'false')
                .find('.performance-segment-mobile-toggle-label')
                .text($(this).text().trim());
            loadPerformancePageTable();
        });

        $('#compare-selected-button').on('click', function(e) {
            var selectedKeys = getPerformancePageCompareSelections().map(function(product) {
                return product.key;
            });

            e.preventDefault();

            if (selectedKeys.length < 2) {
                return;
            }

            openPerformancePageCompareModal();
        });

        $('[data-compare-selection-close]').on('click', function() {
            closePerformancePageCompareModal();
        });

        $(document).on('click.performancePageCompareModal', function(e) {
            if ($('#compare-selection-modal').prop('hidden')) return;
            if ($(e.target).closest('#compare-selection-modal, #compare-selected-button').length) return;

            closePerformancePageCompareModal();
        });

        $('[data-compare-selection-clear]').on('click', function() {
            clearPerformancePageCompareSelections();
        });

        $('[data-compare-selection-submit]').on('click', function() {
            var selectedKeys = getPerformancePageCompareSelections().map(function(product) {
                return product.key;
            });

            if (selectedKeys.length < 2) return;

            sessionStorage.setItem('compareSelectedProducts', selectedKeys.join(','));
            window.location.href = '/fon-karsilastirma';
        });

        $('[data-compare-selection-list]').on('click', '[data-compare-selection-remove]', function() {
            var productKey = $(this).data('compare-selection-remove');
            var $row = $('[data-product-key]').filter(function() {
                return $(this).data('product-key') === productKey;
            });

            removePerformancePageCompareSelection(productKey);
            $row.removeClass('compare-selected');
            $row.find('[data-compare-toggle]').removeClass('selected');
            toggleCompareLimitMessage(false);
            updatePerformancePageCompareButton();
        });

        setPerformancePageCompareSelections($('[data-product-key].compare-selected').map(function() {
            return getPerformancePageProductFromRow($(this));
        }).get());
        loadPerformancePageTable();
    }

    const formatChartNumber = (value, options = {}) => {
        const number = Number(value);
        if (!Number.isFinite(number)) return value;

        return new Intl.NumberFormat('tr-TR', {
            maximumFractionDigits: 2,
            ...options
        }).format(number);
    };

    if ($('#portfolio-chart').length || $('#product-price-history-ajax-body').length) {
        const parseJsonScript = (host, selector) => {
            const script = host.querySelector(selector);
            if (!script) return null;

            try {
                return JSON.parse(script.textContent || 'null');
            } catch {
                return null;
            }
        };

        const initializePortfolioChart = () => {
            const canvas = document.getElementById('portfolio-chart');
            const legendContainer = document.getElementById('portfolio-chart-legend');
            if (!canvas || !legendContainer) return;

            const labels = parseJsonScript(document, '[data-portfolio-chart-labels]') || [];
            const dataValues = parseJsonScript(document, '[data-portfolio-chart-values]') || [];
            const colors = parseJsonScript(document, '[data-portfolio-chart-colors]') || [];
            const updateDate = document.querySelector('[data-portfolio-chart-update-date]')?.dataset.portfolioChartUpdateDate || '';

            if (!labels.length || !dataValues.length || !colors.length) return;

            new Chart(canvas.getContext('2d'), {
                type: 'doughnut',
                data: {
                    labels: labels,
                    datasets: [{
                        data: dataValues,
                        backgroundColor: colors,
                        borderWidth: 2,
                        borderColor: '#ffffff',
                        hoverOffset: 10
                    }]
                },
                options: {
                    cutout: '65%',
                    plugins: {
                        legend: { display: false },
                        tooltip: {
                            enabled: true,
                            callbacks: {
                                label: context => {
                                    const label = context.label || '';
                                    const value = formatChartNumber(context.parsed);

                                    return label ? `${label}: ${value}` : value;
                                }
                            }
                        }
                    },
                    responsive: true,
                    maintainAspectRatio: false,
                    animation: {
                        animateRotate: true,
                        duration: 2000
                    }
                }
            });

            legendContainer.innerHTML = '';
            labels.forEach((label, index) => {
                const value = Number(dataValues[index]);
                legendContainer.insertAdjacentHTML('beforeend', `
                    <div class="legend-item">
                        <span class="dot" style="background-color: ${colors[index]}"></span>
                        <span class="label-text">${label}</span>
                        <span class="percentage">%${Number.isFinite(value) ? value.toFixed(2) : '-'}</span>
                    </div>
                `);
            });

            if (updateDate) {
                const updateDateElement = document.createElement('p');
                updateDateElement.className = 'update-date';
                updateDateElement.textContent = updateDate;
                legendContainer.appendChild(updateDateElement);
            }
        };

        initializePortfolioChart();
    }

    const syncProductPriceDateTools = (link) => {
        const range = link.dataset.priceChartRange || '';
        const section = link.closest('.product-price-history');
        const dateTools = section?.querySelector('[data-price-chart-date-tools], .product-price-history-content-tools:has(form.daterange-picker-component)');
        if (!section || !dateTools) return;

        section.classList.toggle('is-price-date-range-visible', range === 'custom');
        dateTools.hidden = range !== 'custom';
    };

    document.querySelectorAll('.product-price-history [data-price-chart-range]').forEach(link => {
        if (link.closest('.segmented-control-item')?.classList.contains('active')) {
            syncProductPriceDateTools(link);
        }

        link.addEventListener('click', event => {
            event.preventDefault();
            link.closest('.segmented-control-component')?.querySelectorAll('.segmented-control-item').forEach(item => {
                item.classList.toggle('active', item.contains(link));
            });
            syncProductPriceDateTools(link);
        });
    });

    if ($('#product-price-history-ajax-body').length && $('#product-performance-ajax-body').length) {
        const performanceBody = document.getElementById('product-performance-ajax-body');
        const priceBody = document.getElementById('product-price-history-ajax-body');
        const performanceSectionElement = document.getElementById('product-performance-section');
        const comparisonSelect = document.getElementById('price-chart-select');

        priceBody.innerHTML = '';

        const priceState = {
            range: priceBody.dataset.range || 'monthly',
            metric: priceBody.dataset.metric || 'price',
            startDate: priceBody.dataset.startDate || '',
            endDate: priceBody.dataset.endDate || ''
        };
        const returnOrder = performanceBody.querySelector('[data-return-order]')?.dataset.returnOrder || '';
        const additionalSeriesLabels = {
            USD: 'ABD Doları Kapanış Kuru',
            EUR: 'Euro Kapanış Kuru',
            XU100: 'BIST 100 Endeksi Kapanış Değeri',
            XU030: 'BIST 30 Endeksi Kapanış Değeri',
            GLDGR: 'Gram Altın Kapanış Fiyatı',
            KYD1AGMETL: 'BIST-KYD 1 Aylık TL Mevduat Endeksi',
            KYD1AGMUSD: 'BIST-KYD 1 Aylık USD Mevduat Endeksi',
            KYDKARPAY1AYTL: 'BIST-KYD 1 Aylık TL Kâr Payı Endeksi'
        };
        let productPriceChart = null;

        const parseJsonScript = (host, selector) => {
            const script = host.querySelector(selector);
            if (!script) return null;

            try {
                return JSON.parse(script.textContent || 'null');
            } catch {
                return null;
            }
        };

        const togglePerformanceSection = hasData => {
            if (performanceSectionElement) {
                performanceSectionElement.style.display = hasData ? '' : 'none';
            }
        };

        const getNiceStep = value => {
            if (!Number.isFinite(value) || value <= 0) return 1;

            const exponent = Math.floor(Math.log10(value));
            const fraction = value / (10 ** exponent);

            if (fraction <= 1) return 1 * (10 ** exponent);
            if (fraction <= 2) return 2 * (10 ** exponent);
            if (fraction <= 5) return 5 * (10 ** exponent);
            return 10 * (10 ** exponent);
        };

        const syncComparisonAvailability = () => {
            if (comparisonSelect) {
                comparisonSelect.disabled = false;
            }
        };

        const convertSeriesToInvestmentSeries = seriesValues => {
            if (!Array.isArray(seriesValues) || seriesValues.length === 0) return [];

            const numericValues = seriesValues.map(value => Number(value));
            const baseValue = numericValues.find(value => Number.isFinite(value) && value > 0);
            if (!baseValue) return [];

            return numericValues.map(value => {
                if (!Number.isFinite(value) || value <= 0) return null;
                return Number((1000 * (value / baseValue)).toFixed(2));
            });
        };

        const syncComparisonOptions = additionalSeries => {
            if (!comparisonSelect) return;

            const currentValue = comparisonSelect.value;
            comparisonSelect.innerHTML = '<option value="">Seçiniz</option>';

            Object.entries(additionalSeries || {}).forEach(([key, seriesValues]) => {
                if (!Array.isArray(seriesValues) || !seriesValues.some(value => Number(value) > 0)) return;

                const option = document.createElement('option');
                option.value = key;
                option.textContent = additionalSeriesLabels[key] || `${key} Kapanış`;
                comparisonSelect.appendChild(option);
            });

            if (currentValue && comparisonSelect.querySelector(`option[value="${currentValue}"]`)) {
                comparisonSelect.value = currentValue;
            }

            syncComparisonAvailability();
        };

        const updateActiveStates = () => {
            document.querySelectorAll('.product-price-history-content-tools .segmented-control-component.light-bg').forEach((group, groupIndex) => {
                group.querySelectorAll('.segmented-control-item a').forEach(link => {
                    const item = link.closest('.segmented-control-item');
                    if (groupIndex === 0) {
                        item?.classList.toggle('active', (link.dataset.priceChartMetric || 'price') === priceState.metric);
                    } else {
                        item?.classList.toggle('active', (link.dataset.priceChartRange || 'monthly') === priceState.range);
                    }
                });
            });

            const priceSection = document.querySelector('.product-price-history');
            const dateForm = document.querySelector('.product-price-history-content-tools form.components.daterange-picker-component');
            const dateTools = dateForm?.closest('.product-price-history-content-tools');
            const shouldShowDateTools = priceState.range === 'custom';

            priceSection?.classList.toggle('is-price-date-range-visible', shouldShowDateTools);
            if (dateTools) {
                dateTools.hidden = !shouldShowDateTools;
            }
        };

        const initializeProductPriceChart = () => {
            const chartHost = priceBody.querySelector('[data-graphic-chart="product-price"]');
            const canvas = chartHost?.querySelector('.graphic-chart-canvas');
            if (!chartHost || !canvas) return;

            const labels = parseJsonScript(chartHost, '[data-chart-labels]') || [];
            const values = parseJsonScript(chartHost, '[data-chart-values]') || [];
            const additionalSeries = parseJsonScript(chartHost, '[data-chart-additional]') || {};
            syncComparisonOptions(additionalSeries);

            const selectedComparisonKey = comparisonSelect?.value || '';
            const rawSelectedComparisonValues = selectedComparisonKey && Array.isArray(additionalSeries[selectedComparisonKey])
                ? additionalSeries[selectedComparisonKey]
                : [];
            const selectedComparisonValues = priceState.metric === 'investment'
                ? convertSeriesToInvestmentSeries(rawSelectedComparisonValues)
                : rawSelectedComparisonValues;
            const gradient = canvas.getContext('2d').createLinearGradient(0, 0, 0, 300);
            gradient.addColorStop(0, 'rgba(77, 189, 243, 0.4)');
            gradient.addColorStop(1, 'rgba(77, 189, 243, 0.05)');

            const datasets = [{
                label: chartHost.dataset.metricLabel || 'Fon Fiyatı',
                data: values,
                borderColor: '#4dbdf3',
                borderWidth: 2,
                fill: true,
                backgroundColor: gradient,
                pointRadius: 0,
                pointHoverRadius: 5,
                tension: 0
            }];

            if (selectedComparisonKey && selectedComparisonValues.length > 0) {
                datasets.push({
                    label: priceState.metric === 'investment'
                        ? `${additionalSeriesLabels[selectedComparisonKey] || selectedComparisonKey} - 1000 TL Değeri`
                        : (additionalSeriesLabels[selectedComparisonKey] || `${selectedComparisonKey} Kapanış`),
                    data: selectedComparisonValues,
                    borderColor: '#ef6c4d',
                    borderWidth: 2,
                    fill: false,
                    backgroundColor: 'transparent',
                    pointRadius: 0,
                    pointHoverRadius: 5,
                    tension: 0
                });
            }

            const combinedValues = datasets
                .flatMap(dataset => Array.isArray(dataset.data) ? dataset.data : [])
                .map(value => Number(value))
                .filter(value => Number.isFinite(value) && value > 0);
            const baseMinY = Number(chartHost.dataset.minY || 0);
            const baseMaxY = Number(chartHost.dataset.maxY || 1);
            const minValue = combinedValues.length > 0 ? Math.min(...combinedValues) : baseMinY;
            const maxValue = combinedValues.length > 0 ? Math.max(...combinedValues) : baseMaxY;
            const range = maxValue - minValue;
            const padding = range === 0 ? Math.max(maxValue * 0.05, 1) : range * 0.1;
            const minY = datasets.length > 1 ? Math.max(0, Math.floor(minValue - padding)) : baseMinY;
            const maxY = datasets.length > 1 ? Math.ceil(maxValue + padding) : baseMaxY;
            const stepSize = datasets.length > 1 ? getNiceStep((maxY - minY) / 5) : Number(chartHost.dataset.stepSize || 1);

            if (productPriceChart) {
                productPriceChart.destroy();
            }

            productPriceChart = new Chart(canvas.getContext('2d'), {
                type: 'line',
                data: { labels, datasets },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    interaction: {
                        mode: 'index',
                        intersect: false
                    },
                    plugins: {
                        legend: { display: datasets.length > 1 },
                        tooltip: {
                            mode: 'index',
                            intersect: false,
                            backgroundColor: '#0a1c3d',
                            titleColor: '#fff',
                            bodyColor: '#fff',
                            displayColors: false,
                            callbacks: {
                                label: context => {
                                    const label = context.dataset.label || '';
                                    const value = formatChartNumber(context.parsed.y);

                                    return label ? `${label}: ${value}` : value;
                                }
                            }
                        }
                    },
                    scales: {
                        y: {
                            min: minY,
                            max: maxY,
                            ticks: {
                                stepSize,
                                color: '#999',
                                font: { size: 12 },
                                callback: value => formatChartNumber(value)
                            },
                            grid: {
                                color: 'rgba(235, 235, 235, 0.5)',
                                drawBorder: false
                            }
                        },
                        x: {
                            ticks: {
                                color: '#999',
                                font: { size: 12 }
                            },
                            grid: {
                                display: false
                            }
                        }
                    }
                }
            });
        };

        const buildGraphicUrl = () => {
            const params = new URLSearchParams({
                mode: 'product',
                productPageId: priceBody.dataset.productPageId || '',
                range: priceState.range,
                metric: priceState.metric
            });

            if (priceState.range === 'custom' && priceState.startDate && priceState.endDate) {
                params.set('startDate', priceState.startDate);
                params.set('endDate', priceState.endDate);
            }

            if (returnOrder) {
                params.set('returnOrder', returnOrder);
            }

            return `${priceBody.dataset.endpoint}?${params.toString()}`;
        };

        const buildPerformanceUrl = () => {
            const params = new URLSearchParams({
                productPageId: performanceBody.dataset.productPageId || ''
            });

            if (returnOrder) {
                params.set('returnOrder', returnOrder);
            }

            return `${performanceBody.dataset.endpoint}?${params.toString()}`;
        };

        const loadInitialPerformance = async () => {
            if (!performanceBody.dataset.endpoint) return;

            try {
                const response = await fetch(buildPerformanceUrl(), {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest'
                    }
                });

                if (!response.ok) throw new Error(`HTTP ${response.status}`);

                const html = await response.text();
                const temp = document.createElement('div');
                temp.innerHTML = html;
                const performanceSection = temp.querySelector('[data-product-performance-section]');
                const hasPerformanceRows = !!performanceSection?.querySelector('table tbody tr');

                performanceBody.innerHTML = performanceSection?.innerHTML || '';
                togglePerformanceSection(hasPerformanceRows);
                wrapCustomTables($(performanceBody));
                initCustomScrollbars(performanceBody);
            } catch {
                performanceBody.innerHTML = '<div class="alert info-alert"><div class="alert-content"><p>İçerik yüklenemedi.</p></div></div>';
            }
        };

        const loadGraphic = async () => {
            try {
                const priceResponse = await fetch(buildGraphicUrl(), {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest'
                    }
                });

                if (!priceResponse.ok) throw new Error(`HTTP ${priceResponse.status}`);

                const priceHtml = await priceResponse.text();

                const priceTemp = document.createElement('div');
                priceTemp.innerHTML = priceHtml;

                const priceSection = priceTemp.querySelector('[data-product-price-section]');

                priceBody.innerHTML = priceSection?.innerHTML || '';

                wrapCustomTables($(priceBody));
                initCustomScrollbars(priceBody);
                initializeProductPriceChart();
                updateActiveStates();
            } catch {
                priceBody.innerHTML = '<div class="alert info-alert"><div class="alert-content"><p>İçerik yüklenemedi.</p></div></div>';
            }
        };

        document.querySelectorAll('.product-price-history-content-tools .segmented-control-component.light-bg .segmented-control-item a').forEach(link => {
            link.addEventListener('click', event => {
                event.preventDefault();
                priceState.metric = link.dataset.priceChartMetric || priceState.metric;
                priceState.range = link.dataset.priceChartRange || priceState.range;

                if (priceState.range !== 'custom') {
                    priceState.startDate = '';
                    priceState.endDate = '';
                }

                loadGraphic();
            });
        });

        comparisonSelect?.addEventListener('change', () => {
            initializeProductPriceChart();
        });

        const dateForm = document.querySelector('.product-price-history-content-tools form.components.daterange-picker-component');
        if (dateForm) {
            const startInput = dateForm.querySelector('[name="startDate"], [data-performance-table-start]');
            const endInput = dateForm.querySelector('[name="endDate"], [data-performance-table-end]');
            const initialPriceDates = {
                startDate: startInput?.value || priceState.startDate || '',
                endDate: endInput?.value || priceState.endDate || ''
            };
            const applyButtons = dateForm.querySelectorAll('[data-price-chart-date-submit], [data-product-performance-table-submit]');
            const clearButtons = dateForm.querySelectorAll('[data-price-chart-date-clear], [data-product-performance-table-clear]');

            applyButtons.forEach(button => {
                button.addEventListener('click', event => {
                    event.preventDefault();
                    dateForm.requestSubmit ? dateForm.requestSubmit() : dateForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
                });
            });

            clearButtons.forEach(button => {
                button.addEventListener('click', event => {
                    event.preventDefault();
                    startInput && (startInput.value = initialPriceDates.startDate);
                    endInput && (endInput.value = initialPriceDates.endDate);
                    startInput?.classList.remove('is-invalid');
                    endInput?.classList.remove('is-invalid');
                    priceState.range = 'custom';
                    priceState.startDate = initialPriceDates.startDate;
                    priceState.endDate = initialPriceDates.endDate;
                    loadGraphic();
                });
            });

            dateForm.addEventListener('submit', event => {
                event.preventDefault();
                const startDate = startInput?.value || '';
                const endDate = endInput?.value || '';

                startInput?.classList.toggle('is-invalid', !startDate);
                endInput?.classList.toggle('is-invalid', !endDate);

                if (!startDate || !endDate) return;

                if (startDate > endDate) {
                    startInput?.classList.add('is-invalid');
                    endInput?.classList.add('is-invalid');
                    return;
                }

                priceState.range = 'custom';
                priceState.startDate = startDate;
                priceState.endDate = endDate;
                loadGraphic();
            });
        }

        syncComparisonAvailability();
        updateActiveStates();
        loadInitialPerformance();
        loadGraphic();
    }

    // Shared performance date input state
    $('[data-performance-table-start], [data-performance-table-end]').on('change', function() {
        var $input = $(this);
        var $panel = $input.closest('[data-daterange-panel]');

        $panel.data('lastChangedDateInput', $input.is('[data-performance-table-start]') ? 'start' : 'end');
        $input.removeClass('is-invalid');
        validatePerformanceTableDateOrder($panel);
    });

    $(document).on('click', function() {
        $('.product-action').removeClass('active');
    });

    // Hamburger Menu
    const $hamburger = $('.nav__hamburger');
    const $navPanel = $('header nav');

    function openMobileNav() {
        $navPanel.addClass('is-open');
        $hamburger.attr('aria-expanded', 'true');
        $('body').addClass('mobile-nav-open');
    }

    function closeMobileNav() {
        $navPanel.removeClass('is-open');
        $hamburger.attr('aria-expanded', 'false');
        $('body').removeClass('mobile-nav-open');
    }

    $hamburger.on('click', function() {
        if ($navPanel.hasClass('is-open')) {
            closeMobileNav();
        } else {
            openMobileNav();
        }
    });

    // X butonu — nav panel içinden kapat
    $(document).on('click', '.nav__close', function() {
        closeMobileNav();
    });

    // ESC tuşuyla kapat
    $(document).on('keydown', function(e) {
        if (e.key === 'Escape' && $navPanel.hasClass('is-open')) {
            closeMobileNav();
        }
    });
    // End Hamburger Menu

    // Footer accordion (sadece mobilde aktif)
    $('.footer-accordion__header').on('click', function() {
        $(this).closest('.footer-accordion').toggleClass('is-open');
    });

    $(document).on('click', '.performance-mobile-toggle', function() {
        $(this).closest('.performance-row').toggleClass('is-open');
    });


    $(document).on('click', '.product-compare-content-nav-category-item-header', function() {
        if ($('#compare-graphic-container').length) return;

        $('.product-compare-content-nav-category-item').removeClass('expanded');
        $(this).parent().addClass('expanded');
    });

    // Compare page graph/table request
    const compareContainer = document.getElementById('compare-graphic-container');
    if (compareContainer) {
        const compareStorageKey = 'compareSelectedProducts';
        const compareSelectionLimit = 4;

        const parseJsonScript = (host, selector) => {
            const script = host.querySelector(selector);
            if (!script) return null;

            try {
                return JSON.parse(script.textContent || 'null');
            } catch {
                return null;
            }
        };

        const initializeCompareChart = () => {
            const chartHost = compareContainer.querySelector('[data-graphic-chart="compare"]');
            const canvas = chartHost?.querySelector('.graphic-chart-canvas');
            if (!chartHost || !canvas) return;
            const isMobile = window.matchMedia('(max-width: 1024px)').matches;
            const getDatasetCode = dataset => dataset.ProductKey || '';

            const labels = parseJsonScript(chartHost, '[data-chart-labels]') || [];
            const rawDatasets = parseJsonScript(chartHost, '[data-chart-datasets]') || [];
            const isPriceMetric = state.metric === 'price';
            const isInvestmentMetric = state.metric === 'investment';
            const isPerformanceMetric = state.metric === 'performance';
            const getLastFiniteValue = values => {
                if (!Array.isArray(values)) return null;

                for (let index = values.length - 1; index >= 0; index -= 1) {
                    const value = Number(values[index]);

                    if (Number.isFinite(value)) return value;
                }

                return null;
            };
            const getOpaqueChartColor = color => String(color || '#002956')
                .replace(/rgba\(\s*([^,]+),\s*([^,]+),\s*([^,]+),\s*[^)]+\)/i, 'rgb($1, $2, $3)')
                .replace(/hsla\(\s*([^,]+),\s*([^,]+),\s*([^,]+),\s*[^)]+\)/i, 'hsl($1, $2, $3)');
            const useDualYAxis = isPriceMetric && rawDatasets.length > 1;
            //const useDualYAxis = false;
            const getFirstFiniteValue = values => {
                if (!Array.isArray(values)) return null;

                const positiveValue = values.map(Number).find(value => Number.isFinite(value) && value > 0);
                if (Number.isFinite(positiveValue)) return positiveValue;

                return values.map(Number).find(value => Number.isFinite(value)) ?? null;
            };
            const getLogDistance = (value, reference) => {
                const safeValue = Math.max(Number(value) || 0, 0.000001);
                const safeReference = Math.max(Number(reference) || 0, 0.000001);

                return Math.abs(Math.log(safeValue) - Math.log(safeReference));
            };
            const getAxisAssignments = datasets => {
                if (!useDualYAxis) return new Map();

                const indexedValues = datasets
                    .map((dataset, index) => ({ index, value: getFirstFiniteValue(dataset.Data) }))
                    .filter(item => Number.isFinite(item.value));
                if (indexedValues.length < 2) return new Map();

                indexedValues.sort((a, b) => a.value - b.value);
                const leftReference = indexedValues[0];
                const rightReference = indexedValues[indexedValues.length - 1];
                const assignments = new Map([
                    [leftReference.index, 'y'],
                    [rightReference.index, 'y1']
                ]);

                indexedValues.slice(1, -1).forEach(item => {
                    const leftDistance = getLogDistance(item.value, leftReference.value);
                    const rightDistance = getLogDistance(item.value, rightReference.value);

                    assignments.set(item.index, leftDistance <= rightDistance ? 'y' : 'y1');
                });

                return assignments;
            };
            const getCompareNiceStep = value => {
                if (!Number.isFinite(value) || value <= 0) return 1;

                const exponent = Math.floor(Math.log10(value));
                const fraction = value / (10 ** exponent);

                if (fraction <= 1) return 1 * (10 ** exponent);
                if (fraction <= 2) return 2 * (10 ** exponent);
                if (fraction <= 5) return 5 * (10 ** exponent);
                return 10 * (10 ** exponent);
            };
            const getCompareValueScale = chartDatasets => {
                const combinedValues = chartDatasets
                    .flatMap(dataset => Array.isArray(dataset.data) ? dataset.data : [])
                    .map(value => Number(value))
                    .filter(value => Number.isFinite(value));

                if (combinedValues.length === 0) {
                    return {
                        minY: undefined,
                        maxY: undefined,
                        stepSize: undefined
                    };
                }

                const minValue = Math.min(...combinedValues);
                const maxValue = Math.max(...combinedValues);
                const range = maxValue - minValue;
                const padding = range === 0 ? Math.max(Math.abs(maxValue) * 0.1, 1) : range * 0.1;
                const minY = minValue >= 0 ? Math.max(0, minValue - padding) : minValue - padding;
                const maxY = maxValue + padding;

                return {
                    minY,
                    maxY,
                    stepSize: getCompareNiceStep((maxY - minY) / 5)
                };
            };
            const axisAssignments = getAxisAssignments(rawDatasets);
            const lineDatasets = rawDatasets.map((dataset, index) => ({
                label: dataset.Label,
                compareCode: getDatasetCode(dataset),
                data: dataset.Data,
                borderColor: dataset.BorderColor,
                backgroundColor: dataset.BackgroundColor,
                yAxisID: useDualYAxis ? (axisAssignments.get(index) || 'y') : 'y',
                fill: false,
                spanGaps: true,
                tension: 0,
                pointRadius: 0,
                pointHoverRadius: 6
            }));
            const barDatasets = [{
                label: 'Performans',
                data: rawDatasets.map(dataset => getLastFiniteValue(dataset.Data)),
                backgroundColor: rawDatasets.map(dataset => getOpaqueChartColor(dataset.BorderColor || dataset.BackgroundColor)),
                borderColor: rawDatasets.map(dataset => getOpaqueChartColor(dataset.BorderColor || dataset.BackgroundColor)),
                borderWidth: 0,
                borderRadius: 6,
                maxBarThickness: 54
            }];
            const chartLabels = isPerformanceMetric ? rawDatasets.map(dataset => getDatasetCode(dataset)) : labels;
            const datasets = isPerformanceMetric ? barDatasets : lineDatasets;
            const leftAxisDatasets = lineDatasets.filter(dataset => dataset.yAxisID === 'y');
            const rightAxisDatasets = lineDatasets.filter(dataset => dataset.yAxisID === 'y1');
            const leftYAxisTitle = `${leftAxisDatasets.map(dataset => dataset.compareCode || dataset.label).filter(Boolean).join('/')} Birim Fiyat (TL)`;
            const rightYAxisTitle = `${rightAxisDatasets.map(dataset => dataset.compareCode || dataset.label).filter(Boolean).join('/')} Birim Fiyat (TL)`;
            const yAxisTextColor = '#6f7895';
            const leftYAxisScale = isPerformanceMetric ? null : getCompareValueScale(useDualYAxis ? leftAxisDatasets : lineDatasets);
            const rightYAxisScale = useDualYAxis ? getCompareValueScale(rightAxisDatasets) : null;
            const rightYAxisTitlePlugin = {
                id: 'compareRightYAxisTitle',
                afterDraw: chart => {
                    if (!useDualYAxis || rightAxisDatasets.length === 0) return;

                    const scale = chart.scales.y1;
                    if (!scale) return;

                    const { ctx } = chart;
                    ctx.save();
                    ctx.translate(scale.right - 8, (scale.top + scale.bottom) / 2);
                    ctx.rotate(-Math.PI / 2);
                    ctx.fillStyle = yAxisTextColor;
                    ctx.font = `${isMobile ? 12 : 14}px sans-serif`;
                    ctx.textAlign = 'center';
                    ctx.textBaseline = 'middle';
                    ctx.fillText(rightYAxisTitle, 0, 0);
                    ctx.restore();
                }
            };

            new Chart(canvas.getContext('2d'), {
                type: isPerformanceMetric ? 'bar' : 'line',
                data: { labels: chartLabels, datasets },
                plugins: useDualYAxis ? [rightYAxisTitlePlugin] : [],
                options: {
                    responsive: true,
                    maintainAspectRatio: !isMobile,
                    plugins: {
                        legend: { display: false },
                        tooltip: {
                            mode: isPerformanceMetric ? 'nearest' : 'index',
                            intersect: false,
                            usePointStyle: true,
                            boxWidth: 12,
                            boxHeight: 12,
                            multiKeyBackground: 'transparent',
                            callbacks: {
                                labelPointStyle: () => ({ pointStyle: 'rect', rotation: 0 }),
                                labelColor: context => {
                                    const datasetColor = context.dataset.borderColor || context.dataset.backgroundColor;
                                    const color = Array.isArray(datasetColor) ? datasetColor[context.dataIndex] : datasetColor;

                                    return {
                                        borderColor: color,
                                        backgroundColor: color,
                                        borderWidth: 0
                                    };
                                },
                                label: context => {
                                    const label = isPerformanceMetric
                                        ? context.label
                                        : (context.dataset.compareCode || getDatasetCode({ Label: context.dataset.label }));
                                    const value = isPerformanceMetric
                                        ? `%${formatChartNumber(context.parsed.y)}`
                                        : formatChartNumber(context.parsed.y);
                                    return `${label}: ${value}`;
                                }
                            }
                        }
                    },
                    scales: {
                        y: {
                            type: 'linear',
                            min: leftYAxisScale?.minY,
                            max: leftYAxisScale?.maxY,
                            title: {
                                display: useDualYAxis,
                                text: leftYAxisTitle,
                                color: yAxisTextColor,
                                font: { size: isMobile ? 12 : 14 }
                            },
                            ticks: {
                                stepSize: leftYAxisScale?.stepSize,
                                color: useDualYAxis ? yAxisTextColor : '#aeb9e1',
                                font: { size: 10 },
                                callback: value => formatChartNumber(value)
                            },
                            grid: {
                                color: 'rgba(0,0,0,0.05)',
                                drawBorder: false,
                                drawTicks: true
                            }
                        },
                        ...(useDualYAxis ? {
                            y1: {
                                position: 'right',
                                min: rightYAxisScale?.minY,
                                max: rightYAxisScale?.maxY,
                                title: {
                                    display: true,
                                    text: rightYAxisTitle,
                                    color: 'rgba(0, 0, 0, 0)',
                                    font: { size: isMobile ? 12 : 14 }
                                },
                                ticks: {
                                    stepSize: rightYAxisScale?.stepSize,
                                    color: yAxisTextColor,
                                    font: { size: 10 },
                                    callback: value => formatChartNumber(value)
                                },
                                grid: {
                                    drawOnChartArea: false,
                                    drawBorder: false
                                }
                            }
                        } : {}),
                        x: {
                            grid: { display: false },
                            ticks: {
                                color: '#aeb9e1',
                                padding: isMobile ? 5 : 10,
                                font: {
                                    size: isMobile ? 9 : 12
                                }
                            }
                        }
                    }
                }
            });
        };

        const applyStateToControls = state => {
            document.querySelectorAll('.product-compare-box-header .segmented-control-component.light-bg .segmented-control-item a[data-range]').forEach(link => {
                link.closest('.segmented-control-item')?.classList.toggle('active', (link.dataset.range || '') === state.range);
            });

            const bodyToolGroups = document.querySelectorAll('.product-compare-content-body-tools .segmented-control-component.light-bg');
            if (bodyToolGroups.length >= 2) {
                bodyToolGroups[0].querySelectorAll('.segmented-control-item a[data-metric]').forEach(link => {
                    link.closest('.segmented-control-item')?.classList.toggle('active', (link.dataset.metric || 'price') === state.metric);
                });

                bodyToolGroups[1].querySelectorAll('.segmented-control-item a[data-view]').forEach(link => {
                    link.closest('.segmented-control-item')?.classList.toggle('active', (link.dataset.view || 'chart') === state.view);
                });
            }
        };

        const state = {
            products: compareContainer.dataset.products || '',
            range: compareContainer.dataset.range || 'monthly',
            metric: compareContainer.dataset.metric || 'price',
            view: compareContainer.dataset.view || 'chart',
            startDate: compareContainer.dataset.startDate || '',
            endDate: compareContainer.dataset.endDate || ''
        };
        const accordionState = new Map();

        const syncCompareStateFromControls = () => {
            const activeRange = document.querySelector('.product-compare-box-header .segmented-control-item.active a[data-range]');
            const activeMetric = document.querySelector('.product-compare-content-body-tools .segmented-control-item.active a[data-metric]');
            const activeView = document.querySelector('.product-compare-content-body-tools .segmented-control-item.active a[data-view]');

            state.range = activeRange?.dataset.range || compareContainer.dataset.range || state.range || 'monthly';
            state.metric = activeMetric?.dataset.metric || compareContainer.dataset.metric || state.metric || 'price';
            state.view = activeView?.dataset.view || compareContainer.dataset.view || state.view || 'chart';

            compareContainer.dataset.range = state.range;
            compareContainer.dataset.metric = state.metric;
            compareContainer.dataset.view = state.view;
        };

        if (!state.products) {
            state.products = sessionStorage.getItem(compareStorageKey) || '';
            compareContainer.dataset.products = state.products;
        }

        const getSelectedProducts = () =>
            (state.products || '')
                .split(',')
                .map(value => value.trim())
                .filter(Boolean);

        const setSelectedProducts = products => {
            state.products = [...new Set(products.map(value => value.trim()).filter(Boolean))].join(',');
            compareContainer.dataset.products = state.products;

            if (state.products) {
                sessionStorage.setItem(compareStorageKey, state.products);
            } else {
                sessionStorage.removeItem(compareStorageKey);
            }
        };

        const mobileFilterTrigger = document.querySelector('[data-compare-mobile-filter-trigger]');
        const mobileFilterValue = document.querySelector('[data-compare-mobile-filter-value]');
        const mobileFilterModal = document.querySelector('[data-compare-mobile-filter-modal]');
        const mobileFilterClose = document.querySelector('[data-compare-mobile-filter-close]');
        const mobileFilterSubmit = document.querySelector('[data-compare-mobile-filter-submit]');
        const mobileFilterClear = document.querySelector('[data-compare-mobile-filter-clear]');
        const mobileFilterCount = document.querySelector('[data-compare-mobile-filter-count]');
        let mobileDraftProducts = [];

        const formatProductCodes = products => products.length ? products.join(',') : 'Fon seçiniz';

        const syncMobileFilterVisuals = products => {
            const selectedProducts = products || getSelectedProducts();
            const selectedSet = new Set(selectedProducts);

            mobileFilterModal?.querySelectorAll('[data-compare-mobile-product]').forEach(item => {
                const code = item.dataset.productCode || '';
                const isSelected = selectedSet.has(code);
                item.classList.toggle('is-selected', isSelected);
                item.querySelector('[data-compare-mobile-product-toggle]')?.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
            });

            if (mobileFilterValue) {
                mobileFilterValue.textContent = formatProductCodes(selectedProducts);
            }

            if (mobileFilterCount) {
                mobileFilterCount.textContent = String(selectedProducts.length);
            }
        };

        const openMobileFilter = () => {
            if (!mobileFilterModal) return;

            mobileDraftProducts = getSelectedProducts();
            syncMobileFilterVisuals(mobileDraftProducts);
            mobileFilterModal.hidden = false;
            mobileFilterTrigger?.setAttribute('aria-expanded', 'true');
            document.body.classList.add('compare-mobile-filter-open');
        };

        const closeMobileFilter = ({ restore = true } = {}) => {
            if (!mobileFilterModal) return;

            mobileFilterModal.hidden = true;
            mobileFilterTrigger?.setAttribute('aria-expanded', 'false');
            document.body.classList.remove('compare-mobile-filter-open');

            if (restore) {
                mobileDraftProducts = getSelectedProducts();
                syncMobileFilterVisuals(mobileDraftProducts);
            }
        };

        const getFirstComparableProducts = () => {
            const productCodes = [];

            document.querySelectorAll('.product-compare-content-nav-category-item-content-item-code').forEach(codeElement => {
                const code = codeElement.textContent?.trim() || '';
                if (code && !productCodes.includes(code)) {
                    productCodes.push(code);
                }
            });

            document.querySelectorAll('[data-compare-mobile-product]').forEach(item => {
                const code = item.dataset.productCode || '';
                if (code && !productCodes.includes(code)) {
                    productCodes.push(code);
                }
            });

            return productCodes.slice(0, 2);
        };

        if (getSelectedProducts().length === 0) {
            setSelectedProducts(getFirstComparableProducts());
        }

        const updateSelectedProductVisuals = () => {
            const selectedSet = new Set(getSelectedProducts());
            document.querySelectorAll('.product-compare-content-nav-category-item-content li').forEach(item => {
                const codeElement = item.querySelector('.product-compare-content-nav-category-item-content-item-code');
                const code = codeElement?.textContent?.trim() || '';
                item.classList.toggle('selected', selectedSet.has(code));
            });

            syncMobileFilterVisuals(getSelectedProducts());
        };

        const syncCategoryAccordions = () => {
            document.querySelectorAll('.product-compare-content-nav-category-item').forEach(item => {
                const key = item.dataset.categoryKey || '';
                if (!key) return;

                if (!accordionState.has(key)) {
                    accordionState.set(key, item.classList.contains('expanded'));
                }

                item.classList.toggle('expanded', accordionState.get(key) === true);
            });
        };

        const setExpandedCategory = (key, isExpanded) => {
            document.querySelectorAll('.product-compare-content-nav-category-item').forEach(item => {
                const itemKey = item.dataset.categoryKey || '';
                if (itemKey) {
                    accordionState.set(itemKey, itemKey === key ? isExpanded : false);
                }
            });

            syncCategoryAccordions();
        };

        const buildGraphicUrl = currentState => {
            const params = new URLSearchParams({
                mode: 'compare',
                products: currentState.products,
                range: currentState.range,
                metric: currentState.metric,
                view: currentState.view
            });

            if (currentState.range === 'custom') {
                params.set('startDate', currentState.startDate);
                params.set('endDate', currentState.endDate);
            }

            return `${compareContainer.dataset.endpoint}?${params.toString()}`;
        };

        const loadGraphic = async () => {
            if (!compareContainer.dataset.endpoint) return;

            try {
                const response = await fetch(buildGraphicUrl(state), {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest'
                    }
                });

                if (!response.ok) {
                    throw new Error(`HTTP ${response.status}`);
                }

                compareContainer.innerHTML = await response.text();
                initializeCompareChart();
                initCustomScrollbars(compareContainer);
                applyStateToControls(state);
                updateSelectedProductVisuals();
                syncCategoryAccordions();
            } catch {
                compareContainer.innerHTML = '<div class="chart-wrapper" style="width: 100%; max-width: 900px; margin: auto;"><div class="alert info-alert"><div class="alert-content"><p>İçerik yüklenemedi.</p></div></div></div>';
            }
        };

        document.querySelectorAll('.product-compare-box-header .segmented-control-component.light-bg .segmented-control-item a[data-range], .product-compare-content-body-tools .segmented-control-component.light-bg .segmented-control-item a[data-metric], .product-compare-content-body-tools .segmented-control-component.light-bg .segmented-control-item a[data-view]').forEach(link => {
            link.addEventListener('click', event => {
                event.preventDefault();

                if (link.dataset.range) state.range = link.dataset.range;
                if (link.dataset.metric) state.metric = link.dataset.metric;
                if (link.dataset.view) state.view = link.dataset.view;

                if (state.range !== 'custom') {
                    state.startDate = '';
                    state.endDate = '';
                }

                loadGraphic();
            });
        });

        const dateForm = document.querySelector('[data-compare-filter-form]');
        const startDateInput = dateForm?.querySelector('[name="startDate"]');
        const endDateInput = dateForm?.querySelector('[name="endDate"]');
        const initialCompareDates = {
            startDate: startDateInput?.value || state.startDate || '',
            endDate: endDateInput?.value || state.endDate || ''
        };
        const resetCompareDateInputs = () => {
            if (startDateInput) {
                startDateInput.value = initialCompareDates.startDate;
                startDateInput.classList.remove('is-invalid');
            }
            if (endDateInput) {
                endDateInput.value = initialCompareDates.endDate;
                endDateInput.classList.remove('is-invalid');
            }
        };

        if (dateForm) {
            const clearCompareDateRange = () => {
                syncCompareStateFromControls();
                state.startDate = initialCompareDates.startDate;
                state.endDate = initialCompareDates.endDate;
                resetCompareDateInputs();

                loadGraphic();
            };

            dateForm.querySelectorAll('[data-compare-date-submit]').forEach(button => {
                button.addEventListener('click', event => {
                    event.preventDefault();
                    dateForm.requestSubmit ? dateForm.requestSubmit() : dateForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
                });
            });

            dateForm.querySelectorAll('[data-compare-date-clear]').forEach(button => {
                button.addEventListener('click', event => {
                    event.preventDefault();
                    clearCompareDateRange();
                });
            });

            dateForm.addEventListener('submit', event => {
                event.preventDefault();
                const startInput = dateForm.querySelector('[name="startDate"]');
                const endInput = dateForm.querySelector('[name="endDate"]');
                const startDate = startInput?.value || '';
                const endDate = endInput?.value || '';

                startInput?.classList.toggle('is-invalid', !startDate);
                endInput?.classList.toggle('is-invalid', !endDate);

                if (!startDate || !endDate) return;

                state.range = 'custom';
                state.startDate = startDate;
                state.endDate = endDate;
                loadGraphic();
            });
        }

        document.querySelector('[data-clear-range="true"]')?.addEventListener('click', event => {
            if (event.currentTarget.closest('[data-compare-filter-form]')) return;

            event.preventDefault();
            syncCompareStateFromControls();
            state.startDate = initialCompareDates.startDate;
            state.endDate = initialCompareDates.endDate;
            resetCompareDateInputs();

            loadGraphic();
        });

        document.querySelectorAll('.product-compare-content-nav-category-item-content-item-checkbox a').forEach(link => {
            link.addEventListener('click', event => {
                event.preventDefault();

                const listItem = link.closest('li');
                const codeElement = listItem?.querySelector('.product-compare-content-nav-category-item-content-item-code');
                const code = codeElement?.textContent?.trim() || '';
                if (!code) return;

                const selectedProducts = getSelectedProducts();
                if (selectedProducts.includes(code)) {
                    setSelectedProducts(selectedProducts.filter(value => value !== code));
                } else {
                    if (selectedProducts.length >= compareSelectionLimit) {
                        toggleCompareLimitMessage(true);
                        return;
                    }

                    selectedProducts.push(code);
                    setSelectedProducts(selectedProducts);
                }

                toggleCompareLimitMessage(false);
                updateSelectedProductVisuals();
                loadGraphic();
            });
        });

        document.querySelector('.product-compare-box-footer a.btn-outline')?.addEventListener('click', event => {
            event.preventDefault();
            setSelectedProducts([]);
            updateSelectedProductVisuals();
            loadGraphic();
        });

        mobileFilterTrigger?.addEventListener('click', event => {
            event.preventDefault();
            openMobileFilter();
        });

        mobileFilterClose?.addEventListener('click', event => {
            event.preventDefault();
            closeMobileFilter();
        });

        mobileFilterModal?.querySelectorAll('[data-compare-mobile-category-toggle]').forEach(button => {
            button.addEventListener('click', event => {
                event.preventDefault();
                const category = button.closest('[data-compare-mobile-category]');
                if (!category) return;
                category.classList.toggle('is-open');
            });
        });

        mobileFilterModal?.querySelectorAll('[data-compare-mobile-product-toggle]').forEach(button => {
            button.addEventListener('click', event => {
                event.preventDefault();

                const item = button.closest('[data-compare-mobile-product]');
                const code = item?.dataset.productCode || '';
                if (!code) return;

                if (mobileDraftProducts.includes(code)) {
                    mobileDraftProducts = mobileDraftProducts.filter(value => value !== code);
                } else {
                    if (mobileDraftProducts.length >= compareSelectionLimit) {
                        toggleCompareLimitMessage(true, 'mobile');
                        return;
                    }

                    mobileDraftProducts = [...mobileDraftProducts, code];
                }

                toggleCompareLimitMessage(false, 'mobile');
                syncMobileFilterVisuals(mobileDraftProducts);
            });
        });

        mobileFilterSubmit?.addEventListener('click', event => {
            event.preventDefault();

            setSelectedProducts(mobileDraftProducts);
            updateSelectedProductVisuals();
            loadGraphic();
            closeMobileFilter({ restore: false });
        });

        mobileFilterClear?.addEventListener('click', event => {
            event.preventDefault();
            mobileDraftProducts = [];
            toggleCompareLimitMessage(false, 'mobile');
            syncMobileFilterVisuals(mobileDraftProducts);
        });

        document.addEventListener('keydown', event => {
            if (event.key === 'Escape' && mobileFilterModal && !mobileFilterModal.hidden) {
                closeMobileFilter();
            }
        });

        document.querySelector('.product-compare-content-nav')?.addEventListener('click', event => {
            const header = event.target.closest('.product-compare-content-nav-category-item-header');
            if (!header) return;

            const item = header.closest('.product-compare-content-nav-category-item');
            const key = item?.dataset.categoryKey || '';
            if (!item || !key) return;

            setExpandedCategory(key, !item.classList.contains('expanded'));
        });

        syncCategoryAccordions();
        updateSelectedProductVisuals();
        loadGraphic();
    }

    // Scroll-down icon: hide on scroll, restore at top
    const scrollDownIcons = gsap.utils.toArray(".hero .scroll-down");
    if (scrollDownIcons.length) {
        ScrollTrigger.create({
            start: 1,
            onEnter: () => gsap.to(scrollDownIcons, { opacity: 0, duration: 0.25, ease: "power1.out", overwrite: "auto" }),
            onLeaveBack: () => gsap.to(scrollDownIcons, { opacity: 1, duration: 0.25, ease: "power1.out", overwrite: "auto" }),
        });
    }

    gsap.matchMedia().add("(min-width: 769px)", () => {
        ScrollTrigger.create({
            trigger: ".hero .slider",
            start: "top top",
            onEnter: () => {
                const header = document.querySelector('header');

                animateElement(header, {
                    opacity: 0,
                    duration: 0.3,
                    onComplete: () => header.classList.add('collapsed')
                });
            },
            onLeaveBack: () => {
                const header = document.querySelector('header');
                animateElement(header, {
                    opacity: 1,
                    duration: 0.3,
                    onComplete: () => header.classList.remove('collapsed')
                });
            }
        });
    });

    //End Menu    

    //FAQ
    $('.product-page section.product-documents .section-header').on('click', function() {
        $(this).parent().toggleClass('active');
    });

    $('.product-page section.product-documents .section-content .section-body .document-item.expandable .document-name').on('click', function() {
        $(this).parent().parent().toggleClass('active');
    });
    //End FAQ
    //DOCUMENTS
    $('.faq .items .item h3').on('click', function() {
        $(this).parent().toggleClass('active');
    });
    //End DOCUMENTS

    // Notifications
    $('.header-top-content').owlCarousel({
        loop: true,
        margin: 0,
        nav: false,
        dots: false,
        autoplay: true,
        autoplayTimeout: 3000,
        autoplayHoverPause: true,
        items: 1,
        animateOut: 'slideOutUp', // Yukarı doğru çıksın
        animateIn: 'slideInUp',   // Aşağıdan yukarıya gelsin
        mouseDrag: false,         // Dikeyde sürükleme garip duracağı için kapattık
        touchDrag: false,
        pullDrag: false
    });

    //End Notifications

    //Home Page

    var ww = $(window).width();

    if(ww < 1024){
        $('body.home-page .hero .slider .slide').each(function(index, element){
            var imageUrl = $(element).data('bg-mobile-image');
            console.log("1024<<<<",imageUrl)
            $(element).css('background-image', 'url('+ imageUrl +')');
        })
    }else{
        $('body.home-page .hero .slider .slide').each(function(index, element){
            var imageUrl = $(element).data('bg-image');
            console.log(imageUrl)
            $(element).css('background-image', 'url('+ imageUrl +')');
        })
    }


    var $heroSlider = $('body.home-page .hero .slider');
    var heroSlideCount = $heroSlider.children().length;
    $heroSlider.owlCarousel({
        loop: heroSlideCount > 1,
        margin: 0,
        nav: false,
        dots: heroSlideCount > 1,
        autoplay: heroSlideCount > 1,
        autoplayTimeout: 5000,
        autoplayHoverPause: true,
        items: 1,
    });

    var projectGalleryOptions = {
        loop: false,
        margin: 16,
        nav: true,
        dots: false,
        navContainer: '.product-project-page .project-gallery .custom-nav-wrapper',
        autoplay: false,
        stagePadding: 30,
        slideBy: 1,
        onInitialized: function(event) {
            updateProgressBar(event);
        },
        onTranslated: updateProgressBar,
        onRefreshed: updateProgressBar,
        responsive: {
            0:    { items: 1 },
            768:  { items: 2 },
            1024: { items: 2 },
        },
    };

    $('.product-project-page .project-gallery .project-gallery-items').owlCarousel(projectGalleryOptions);

    $('.product-recommendations .product-carousel .items').owlCarousel({
        loop: false,
        margin: 15,
        nav: true,
        dots: false,
        navContainer: '.product-recommendations .custom-nav-wrapper',
        autoplay: false,
        stagePadding: 15,
        slideBy: 1,
        onInitialized: function(event) {
            updateProgressBar(event);
        },
        onTranslated: updateProgressBar,
        onRefreshed: updateProgressBar,
        responsive: {
            0:    { items: 1, stagePadding: 15 },
            768:  { items: 2, stagePadding: 15 },
            1024: { items: 3, stagePadding: 15 },
            1366: { items: 3, stagePadding: 15 },
            1440: { items: 3, stagePadding: 15 },
        },
    });

    $('body.home-page .media .sub-section.news .items').owlCarousel({
        loop: false,
        margin: 15,
        nav: true,
        dots: false,
        navContainer: '.media .sub-section.news .custom-nav-wrapper',
        autoplay: false,
        stagePadding: 15,
        slideBy: 1,
        onInitialized: function(event) {
            updateProgressBar(event);
        },
        onTranslated: updateProgressBar,
        onRefreshed: updateProgressBar,
        responsive: {
            0:    { items: 1, stagePadding: 15 },
            768:  { items: 2, stagePadding: 15 },
            1024: { items: 3, stagePadding: 15 },
        },
    });

    $('body.home-page .media .sub-section.blog .items').owlCarousel({
        loop: false,
        margin: 15,
        nav: true,
        dots: false,
        navContainer: '.media .sub-section.blog .custom-nav-wrapper',
        autoplay: false,
        stagePadding: 15,
        slideBy: 1,
        onInitialized: function(event) {
            updateProgressBar(event);
        },
        onTranslated: updateProgressBar,
        onRefreshed: updateProgressBar,
        responsive: {
            0:    { items: 1, stagePadding: 15 },
            768:  { items: 2, stagePadding: 15 },
            1024: { items: 3, stagePadding: 15 },
        },
    });

    $('body.home-page .media .sub-section.announcements .items').owlCarousel({
        loop: false,
        margin: 15,
        nav: true,
        dots: false,
        navContainer: '.media .sub-section.announcements .custom-nav-wrapper',
        autoplay: false,
        stagePadding: 15,
        slideBy: 1,
        onInitialized: function(event) {
            updateProgressBar(event);
        },
        onTranslated: updateProgressBar,
        onRefreshed: updateProgressBar,
        responsive: {
            0:    { items: 1, stagePadding: 15 },
            768:  { items: 2, stagePadding: 15 },
            1024: { items: 3, stagePadding: 15 },
        },
    });

    //End Home Page

    //Products Page

    // Auto-scroll products nav to active item
    const $productsNav = $('.products nav ul');
    const $activeNavItem = $productsNav.find('li.active');
    if ($productsNav.length && $activeNavItem.length) {
        const itemLeft = $activeNavItem[0].offsetLeft;
        const itemWidth = $activeNavItem[0].offsetWidth;
        const containerWidth = $productsNav[0].offsetWidth;
        $productsNav[0].scrollLeft = itemLeft - (containerWidth / 2) + (itemWidth / 2);
    }

    $('.products .product-carousel .items').owlCarousel({
        loop: false,
        margin: 15,
        nav: true,
        dots: false,
        navContainer: '.products .product-carousel .custom-nav-wrapper',
        autoplay: false,
        stagePadding: 0,
        slideBy: 1,
        onInitialized: function(event) {
            updateProgressBar(event);
        },
        onTranslated: updateProgressBar,
        onRefreshed: updateProgressBar,
        responsive: {
            0:    { items: 1, stagePadding: 0 },
            768:  { items: 1, stagePadding: 0 },
            1024: { items: 1, stagePadding: 0 },
            1280: { items: 2, stagePadding: 0 },
        },
    });

    // Segmented Control — auto-scroll to active item on load
    $('.blog-page .segmented-control-component.multiple.single-selection').each(function() {
        const $container = $(this);
        const $activeItem = $container.find('.segmented-control-item.active');
        if ($activeItem.length) {
            const itemLeft = $activeItem[0].offsetLeft;
            const itemWidth = $activeItem[0].offsetWidth;
            const containerWidth = $container[0].offsetWidth;
            $container[0].scrollLeft = itemLeft - (containerWidth / 2) + (itemWidth / 2);
        }
    });

    //End Products Page

    //About Page

    gsap.matchMedia().add("(min-width: 1025px)", () => {
        const aboutHeroSection = document.querySelector(".about-page .hero");
        const aboutStoryContent = document.querySelector(".about-page .hero .about-story-content");
        const aboutStoryParagraphs = gsap.utils.toArray(".about-page .hero .about-story-content p");
        const aboutHeroScrollDown = document.querySelector(".about-page .hero .scroll-down");
        const aboutHeroSectionBgOverlay = document.querySelector(".about-page .hero .section-bg-overlay");

        if (aboutHeroSection && aboutStoryContent && aboutStoryParagraphs.length) {
            const lineHighlightBackgroundMiddle = "linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.92) 52%, rgba(255, 255, 255, 0) 100%)";
            const lineHighlightBackgroundTop = "linear-gradient(180deg, rgba(255, 255, 255, 0.92) 0%, rgba(255, 255, 255, 0.72) 18%, rgba(255, 255, 255, 0) 100%)";
            const lineHighlightBackgroundBottom = "linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.72) 82%, rgba(255, 255, 255, 0.92) 100%)";

            gsap.set(aboutStoryParagraphs, { opacity: 0.3 });

            const updateAboutStory = () => {
                const viewportHeight = window.innerHeight;
                const centerY = viewportHeight * 0.5;
                const fullBand = viewportHeight * 0.2;
                const midBand = viewportHeight * 0.35;
                const lineHighlightHeight = Math.max(180, Math.min(viewportHeight * 0.28, 320));
                const heroRect = aboutHeroSection.getBoundingClientRect();
                const storyActive = Math.abs(heroRect.top) > Math.max(40, viewportHeight * 0.08);
                const storyStartOffset = parseFloat(window.getComputedStyle(aboutStoryContent).paddingTop) || 0;
                const highlightHalfHeight = lineHighlightHeight / 2;
                const minHighlightTop = storyStartOffset + highlightHalfHeight;
                const maxHighlightTop = Math.max(minHighlightTop, aboutStoryContent.offsetHeight - highlightHalfHeight);

                let lineOpacity = 0.3;
                let lineHighlightOpacity = 0.32;
                let activeParagraphTop = Math.max(minHighlightTop, Math.min(aboutStoryContent.offsetHeight * 0.5, maxHighlightTop));
                let highlightBackground = lineHighlightBackgroundMiddle;
                let closestParagraphDistance = Number.POSITIVE_INFINITY;

                aboutHeroSection.classList.toggle("story-active", storyActive);
                gsap.set(aboutStoryContent, { "--about-story-line-highlight-height": `${lineHighlightHeight}px` });

                if (aboutHeroSectionBgOverlay) {
                    gsap.to(aboutHeroSectionBgOverlay, {
                        backgroundColor: storyActive ? "rgba(0, 41, 86, 0.9)" : "rgba(0, 41, 86, 0.8)",
                        duration: 0.35,
                        ease: "power1.out",
                        overwrite: "auto",
                    });
                }

                if (!storyActive) {
                    gsap.to(aboutStoryContent, { "--about-story-line-opacity": 0, "--about-story-line-highlight-opacity": 0, duration: 0.3, overwrite: "auto" });
                    gsap.set(aboutStoryContent, { "--about-story-line-highlight-top": `${activeParagraphTop}px`, "--about-story-line-highlight-background": highlightBackground });
                    gsap.to(aboutStoryParagraphs, { opacity: 0.3, duration: 0.3, overwrite: "auto" });
                    return;
                }

                aboutStoryParagraphs.forEach((paragraph) => {
                    const rect = paragraph.getBoundingClientRect();
                    const distance = Math.abs(rect.top + rect.height / 2 - centerY);
                    const opacity = distance <= fullBand ? 1 : distance <= midBand ? 0.6 : 0.3;

                    gsap.to(paragraph, { opacity, duration: 0.25, overwrite: "auto" });
                    lineOpacity = Math.max(lineOpacity, opacity);
                    lineHighlightOpacity = Math.max(lineHighlightOpacity, opacity * 0.9);

                    if (distance < closestParagraphDistance) {
                        closestParagraphDistance = distance;
                        const clampedTop = Math.max(minHighlightTop, Math.min(paragraph.offsetTop + paragraph.offsetHeight / 2, maxHighlightTop));
                        activeParagraphTop = clampedTop;
                        highlightBackground = clampedTop <= minHighlightTop + 1
                            ? lineHighlightBackgroundTop
                            : clampedTop >= maxHighlightTop - 1
                                ? lineHighlightBackgroundBottom
                                : lineHighlightBackgroundMiddle;
                    }
                });

                gsap.to(aboutStoryContent, { "--about-story-line-opacity": lineOpacity, "--about-story-line-highlight-opacity": lineHighlightOpacity, duration: 0.25, overwrite: "auto" });
                gsap.set(aboutStoryContent, { "--about-story-line-highlight-top": `${activeParagraphTop}px`, "--about-story-line-highlight-background": highlightBackground });
            };

            ScrollTrigger.create({
                trigger: aboutHeroSection,
                start: "top bottom",
                end: "bottom top",
                onUpdate: updateAboutStory,
                onRefresh: updateAboutStory,
            });

            updateAboutStory();
        }

    });

    //End About Page

    // About page mobile: pin ::before background until end of story layout
    gsap.matchMedia().add("(max-width: 1024px)", () => {
        const heroSection = document.querySelector(".about-page .hero");
        const storyLayout = document.querySelector(".about-page .hero .about-story-layout");

        if (!heroSection || !storyLayout) return;

        ScrollTrigger.create({
            trigger: heroSection,
            start: "top top",
            endTrigger: storyLayout,
            end: "bottom bottom",
            onEnter: () => {
                heroSection.classList.add("hero-bg-fixed");
                heroSection.classList.remove("hero-bg-bottom");
            },
            onLeave: () => {
                heroSection.classList.remove("hero-bg-fixed");
                heroSection.classList.add("hero-bg-bottom");
            },
            onEnterBack: () => {
                heroSection.classList.add("hero-bg-fixed");
                heroSection.classList.remove("hero-bg-bottom");
            },
            onLeaveBack: () => {
                heroSection.classList.remove("hero-bg-fixed");
                heroSection.classList.remove("hero-bg-bottom");
            },
        });
    });

    //Aside Navigation — sadece desktop'ta pinle
    gsap.matchMedia().add("(min-width: 769px)", () => {
        ScrollTrigger.create({
            trigger: ".page-container .page-content-body",
            start: "top-=90 top",
            endTrigger: ".page-container",
            end: "bottom bottom",
            pin: "aside",
            pinSpacing: false,
            anticipatePin: 1,
        });
    });
    //End Aside Navigation

    // Aside Mobile Dropdown
    const $asideMobileToggle = $('.aside-mobile-toggle');
    if ($asideMobileToggle.length) {
        const $asideContent = $asideMobileToggle.closest('.aside-content');
        const $activeLink = $asideContent.find('nav > ul > li.active > a');
        const activeText = $activeLink.clone().children('i').remove().end().text().trim();
        $asideMobileToggle.find('.aside-mobile-toggle-label').text(activeText || 'Menü');

        $asideMobileToggle.on('click', function() {
            const isOpen = $asideContent.hasClass('is-open');
            $asideContent.toggleClass('is-open', !isOpen);
            $(this).attr('aria-expanded', String(!isOpen));
        });
    }
    // End Aside Mobile Dropdown

    // Performance segmented control mobile dropdown
    $('.performance-segment-mobile-toggle').each(function() {
        const $toggle = $(this);
        const $toolsItem = $toggle.closest('.product-performance-content-tools-item');
        const $activeItem = $toolsItem.find('.segmented-control-item.active').first();
        const activeText = $activeItem.find('a').text().trim();

        $toggle.find('.performance-segment-mobile-toggle-label').text(activeText || 'Seçiniz');

        $toggle.on('click', function() {
            const isOpen = $toolsItem.hasClass('is-open');
            $toolsItem.toggleClass('is-open', !isOpen);
            $toggle.attr('aria-expanded', String(!isOpen));
        });

        $toolsItem.find('.segmented-control-item a').on('click', function() {
            const selectedText = $(this).text().trim();

            $toggle.find('.performance-segment-mobile-toggle-label').text(selectedText || 'Seçiniz');
            $toolsItem.removeClass('is-open');
            $toggle.attr('aria-expanded', 'false');
        });
    });
    // End Performance segmented control mobile dropdown

    // Fancybox — project gallery: only close button
    $('[data-fancybox="project-gallery"]').fancybox({
        buttons: ['close'],
        hash: false,
        afterClose: function() {
            var $carousel = $('.product-project-page .project-gallery .project-gallery-items');
            $carousel.hide();
            $carousel[0].offsetHeight; // force reflow
            $carousel.show();
        },
    });

    //Helper Functions

    $.fn.openAjaxContent = function(url) {
        $.fancybox.open({
            type: 'ajax',
            src: url,
        });
    }

    $.fn.scrollToElement = function(element) {
        const elementPosition = $(element).offset().top;
        const offsetPosition = elementPosition - 100;
        $('html, body').animate({
            scrollTop: offsetPosition,
            ease: "power2.out",
            delay: 0
        }, 250);
    }

    $('.scroll-to-element-trigger').on('click', function(e) {
        e.preventDefault();
        const element = $(this).data('element') || $(this).attr('href');
        $(this).scrollToElement(element);
    });

    $('.ajax-content-trigger').on('click', function(e) {
        e.preventDefault();
        const url = $(this).data('url') || $(this).attr('href');
        $(this).openAjaxContent(url);
    });

    $('.components.segmented-control-component.owl-carousel').owlCarousel({
        loop: false,
        margin: 0,
        nav: true,
        dots: false,
        autoplay: false,
        items: 6,
        stagePadding: 60,
    });


    const scrollProgress = {
        container: document.getElementById('scroll-progress-container'),
        bar: document.querySelector('.scroll-progress .progress-bar'),
        text: document.querySelector('.scroll-progress .progress-text'),
        circleLength: 188.4,
        percentageSpan: document.querySelector('.scroll-progress .progress-percentage'),
    
        init() {
            if(this.container) {
                window.addEventListener('scroll', () => this.update());
                window.addEventListener('resize', () => this.update());
                this.update(); // İlk yüklemede kontrol et
                // Bonus: Tıklayınca yukarı çıkma
                this.container.addEventListener('click', () => {
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                });
            }
        },
    
        update() {
            if (window.innerWidth < 1024) {
                if (this.container.classList.contains('is-visible')) {
                    this.container.classList.remove('is-visible');
                }
                return;
            }

            const scrollHeight = document.documentElement.scrollHeight;
            const windowHeight = window.innerHeight;
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const scrollableDistance = scrollHeight - windowHeight;

            if (scrollHeight > windowHeight + 100) {
                this.container.classList.add('is-visible');
            } else {
                this.container.classList.remove('is-visible');
                return;
            }

            // 1. Yüzde Hesaplama
            const scrollPercentage = Math.round((scrollTop / scrollableDistance) * 100);
            
            // 2. SVG Halka Güncelleme (HER ZAMAN, %100'e kadar devam eder)
            const offset = this.circleLength - (Math.min(scrollPercentage, 100) / 100) * this.circleLength;
            this.bar.style.strokeDashoffset = offset;

            // 3. KRİTİK KOŞUL: %90 ve Üstü Kontrolü
            if (scrollPercentage >= 90) {
                // Class ekle -> CSS yüzdeyi gizler, ikonu gösterir
                this.container.classList.add('is-near-top');
                // Opsiyonel: Erişilebilirlik için başlığı güncelle
                this.container.setAttribute('title', 'Yukarı Çık / Tap to top');
            } else {
                // Class çıkar -> CSS yüzdeyi geri getirir, ikonu gizler
                this.container.classList.remove('is-near-top');
                // Sadece %90'ın altındayken yüzde metnini güncelle
                this.percentageSpan.innerText = `${scrollPercentage}%`;
                this.container.removeAttribute('title');
            }

            // En üste gelince tekrar gizle
            if (scrollTop < 50) this.container.classList.remove('is-visible');
        }
    };
    
    scrollProgress.init()

    function updateProgressBar(event) {
        if (!event.namespace) return;

        var $carousel = $(event.target);
        var $progressBar = $carousel.closest('.carousel-container').find('.owl-progress-bar');

        // Owl Carousel verilerini alalım
        var itemsCount = event.item.count;     // Toplam item sayısı (örn: 10)
        var itemIndex  = event.item.index;     // Mevcut ilk item'ın indeksi (0, 1, 2...)
        var pageSize   = event.page.size;      // Ekranda görünen item sayısı (senin kodunda 3)

        // Senior Mantığı: 
        // Barın konumu = (Mevcut indeks + Ekranda görünenlerin sayısı) / Toplam sayı
        // Bu sayede 1. itemdayken bar (0+3)/10 = %30'dan başlar, son itemda (7+3)/10 = %100 olur.
        var percentage = ((itemIndex + pageSize) / itemsCount) * 100;

        // Sınırları koruyalım (Özellikle stagePadding veya loop varken taşma yapmasın)
        if (percentage > 100) percentage = 100;
        if (percentage < 0) percentage = 0;

        // İlk yüklemede (index 0 iken) süre 0 olsun ki sıçrama yapmasın
        var animDuration = (itemIndex === 0 && event.type === 'initialized') ? 0 : 0.4;

        gsap.to($progressBar, {
            width: percentage + "%",
            duration: animDuration,
            ease: "power2.out"
        });
    }
});

document.addEventListener("DOMContentLoaded", function() {
    const body = document.body;
    const loader = document.getElementById('global-loader');
    
    const isTargetPage = body.classList.contains('page');
    const hasVisited = localStorage.getItem('hasSeenSplash');

    if (!hasVisited) {
        loader.style.display = 'flex';
        body.classList.add('stop-scrolling');
        window.addEventListener('load', function() {
            setTimeout(() => {
                loader.classList.add('loader-hidden');
                body.classList.remove('stop-scrolling');
                localStorage.setItem('hasSeenSplash', 'true');
            }, 1500); 
        });
    } else {
        if(loader) {
            loader.remove();            
        }
    }
});
